import { useWLDefaultMarketAccount } from '@talos/kyoko';

export function useGCashDefaultMarketAccount() {
  const { defaultMarketAccount } = useWLDefaultMarketAccount();
  return defaultMarketAccount ?? 'default';
}
